import { 
    ROUTE_PATH_EMPLOYEE_DOCUMENTS, 
    ROUTE_PATH_EMPLOYEE_E_LEARNING, 
    ROUTE_PATH_EMPLOYEE_HOME, 
    ROUTE_PATH_EMPLOYEE_TUTORIAL 
} from "src/common/constants";
import { ROLE_TASK_OWNER } from "src/components/constants";
import { 
    ROUTE_PATH_EMPLOYEE_BREACH_INCIDENT_REQUEST, 
    ROUTE_PATH_EMPLOYEE_DATA_SUBJECT_REQUEST, 
    ROUTE_PATH_EMPLOYEE_DEVICE_AGENT, 
    ROUTE_PATH_EMPLOYEE_REPORTS_LIST,
    ROUTE_PATH_EMPLOYEE_TASKS_LIST
} from "src/modules/data-protection/constants";

const EmployeeMenuItems = [
    {
        titleKey    :   "Home",
        linkType    :   "react-router",
        path        :   ROUTE_PATH_EMPLOYEE_HOME,
        icon        :   "ri-home-4-line",
        authProtected   :   true,
        settingKey      :   null,
        moduleFeatures  :   [],
        roles           :   [],
        customValidator :   null
    },
    {
        titleKey    :   "My reports",
        linkType    :   "react-router",
        path        :   ROUTE_PATH_EMPLOYEE_REPORTS_LIST,
        // Report details use incident-register / data-subject-request detail URLs
        matchPaths  :   [
            "/employee/data-protection/incident-register",
            "/employee/data-protection/data-subject-request/details",
        ],
        icon        :   "ri-mail-line",
        authProtected   :   true,
        settingKey      :   null,
        moduleFeatures  :   [],
        roles           :   [],
        customValidator :   null
    },
    {
        titleKey        :   "My Tasks",
        path            :   ROUTE_PATH_EMPLOYEE_TASKS_LIST,
        icon            :   "ri-pencil-line",
        linkType        :   "react-router",
        authProtected   :   true,
        settingKey      :   null,
        moduleFeatures  :   [],
        roles           :   [
            ROLE_TASK_OWNER
        ],
        customValidator :   null
    },
    {
        titleKey    :   "Add a new report",
        linkType    :   "react-router",
        path        :   null,
        icon        :   "ri-mail-send-line",
        authProtected   :   true,
        settingKey      :   null,
        roles           :   [],
        moduleFeatures  :   [],
        customValidator :   null,
        items: [
            {
                titleKey    :   ({ t, orgCustomization }) => {
                    return t(orgCustomization?.gd?.dataBreachTitle || "Data Breach Incident")
                },
                linkType    :   "react-router",
                path        :   ROUTE_PATH_EMPLOYEE_BREACH_INCIDENT_REQUEST,
                authProtected   :   false,
                settingKey      :   null,
                roles           :   [],
                moduleFeatures  :   [],
                customValidator :   null
            },
            {
                titleKey    :   ({ t, orgCustomization }) => {
                    return t(orgCustomization?.gd?.otherRequestTitle || "Other Requests")
                },
                linkType    :   "react-router",
                path        :   ROUTE_PATH_EMPLOYEE_DATA_SUBJECT_REQUEST,
                moduleFeatures  :   [],
                authProtected   :   true,
                settingKey      :   null,
                roles           :   [],
                customValidator :   null
            }
        ]
    },
    {
        titleKey    :   "Integration",
        linkType    :   "react-router",
        path        :   null,
        icon        :   "ri-links-line",
        authProtected   :   true,
        settingKey      :   null,
        roles           :   [],
        moduleFeatures  :   ['software-fetch'],
        customValidator :   null,
        items: [
            {
                titleKey    :   "Software Sync",
                linkType    :   "react-router",
                path        :   ROUTE_PATH_EMPLOYEE_DEVICE_AGENT,
                authProtected   :   true,
                settingKey      :   null,
                roles           :   [],
                moduleFeatures  :   ['software-fetch'],
                customValidator :   null
            }
        ]
    },
    // {
    //     titleKey    :   "Documents",
    //     linkType    :   "react-router",
    //     path        :   ROUTE_PATH_EMPLOYEE_DOCUMENTS,
    //     icon        :   "ri-book-open-line",
    //     moduleFeatures  :   ['Documents'],
    //     authProtected   :   true,
    //     settingKey      :   null,
    //     roles           :   [],
    //     customValidator :   null
    // },
    {
        titleKey    :   "E-Learning",
        path        :   ROUTE_PATH_EMPLOYEE_E_LEARNING,
        icon        :   "ri-video-line",
        linkType    :   "react-router",
        moduleFeatures  :   [],
        authProtected   :   true,
        settingKey      :   "isElearning",
        roles           :   [],
        customValidator :   null
    },
    {
        titleKey    :   "Tutorial",
        path        :   ROUTE_PATH_EMPLOYEE_TUTORIAL,
        icon        :   "ri-video-line",
        linkType    :   "react-router",
        moduleFeatures  :   [],
        authProtected   :   true,
        settingKey      :   null,
        roles           :   [],
        customValidator :   null
    }
];

export default EmployeeMenuItems;
